<template>
<div id="nissan-quiz-lose-ipad" class="nissan-quiz-screen">
   <div class="timesupHeadline" v-if="this.config.tierType === 'TIER2'">THANKS FOR PLAYING</div>
   <img class="indicator" src="../assets/game-lost-indicator.png" alt="">
   <div v-if="this.config.tierType === 'TIER2'">
    <div class="timesupTitle">BETTER LUCK<br>NEXT TIME</div>
    <div class="timesupSubtitle">DON’T FORGET TO COME<br>BACK AND PLAY AGAIN!</div>
   </div>
   <div v-if="this.config.tierType === 'TSF' || this.config.tierType === 'CORP' || this.config.tierType === 'TIER1'">
    <div class="timesupTitle">THANKS FOR<br>PLAYING!</div>
    <div class="timesupSubtitle">YOU EARNED A STAMP<br>ON YOUR THRILL PASS<br>WRISTBAND.<br>SHOW THIS SCREEN TO<br>A BRAND AMBASSADOR.</div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'IncorrectEnd',
  computed: {
    ...mapGetters([
      'config',
      'gameRoomId',
    ]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
 @import './../styles/_global.scss';
 @import './../styles/_variables.scss';


#nissan-quiz-lose-ipad {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  background-color: #00000040;
}

.indicator {
  width: 50px;
  margin: 10px auto;
  display: block;
}

.timesupHeadline {
  text-align: center;
  width: 100%;
  position: absolute;
  top: 10px;
  font-size: 20px;
}

.timesupTitle {
  text-align: center;
  width: 100%;
  font-size: 40px;
  margin-bottom: 20px;
}

.timesupSubtitle {
  text-align: center;
  width: 100%;
  font-size: 27px;
}
@media only screen and (max-width: 320px) {
  .timesupHeadline {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 10px;
    font-size: 10px;
  }

  .timesupTitle {
    font-size: 30px;
    margin-bottom: 20px;
  }

  .timesupSubtitle {
    font-size: 20px;
  }
}
</style>
